import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 218 176"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M338 .055c0-34.863-9.918-68.912-28.531-97.807s-44.97-51.549-75.811-64.843-64.806-16.821-97.685-10.039c-32.743 6.783-62.904 23.604-86.544 48.158C25.789-99.923 9.757-68.451 3.236-34.401-3.286-.216.11 35.19 12.882 67.34c12.77 32.15 34.509 59.689 62.225 78.952C102.958 165.69 135.565 176 168.987 176c44.835 0 87.767-18.585 119.559-51.549C320.202 91.487 338 46.721 338 .055M168.987 92.708c-17.662 0-34.78-5.427-49.453-15.6-14.673-10.175-26.086-24.69-32.743-41.647a94.95 94.95 0 0 1-5.027-53.583c3.397-18.043 11.956-34.457 24.319-47.48 12.5-13.023 28.26-21.84 45.514-25.367s35.188-1.764 51.492 5.29 30.161 18.856 39.943 34.185c9.782 15.194 14.945 33.236 14.945 51.55 0 24.417-9.238 48.021-25.814 65.385-16.575 17.364-39.128 27.267-62.632 27.402h-.544z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }